import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import metadata from './BusinessOperations2Component.metadata.json5';

import styles from '../MedicalPractitioners.module.scss';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function BusinessOperations2Component(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('BusinessOperations2Component');
    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = true


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        iWhaTraHavTheAppOr4: {
            visible: !_.isUndefined(modelVM.value.doYouOrAnyOfYouEmp3) && modelVM.value.doYouOrAnyOfYouEmp3
        },
        iiHowOftAreTheEmpRet5: {
            visible: !_.isUndefined(modelVM.value.doYouOrAnyOfYouEmp3) && modelVM.value.doYouOrAnyOfYouEmp3
        },
        iiiIsTheATimWheA6: {
            visible: !_.isUndefined(modelVM.value.doYouOrAnyOfYouEmp3) && modelVM.value.doYouOrAnyOfYouEmp3
        },
        ivIsTheAManHanLif7: {
            visible: !_.isUndefined(modelVM.value.doYouOrAnyOfYouEmp3) && modelVM.value.doYouOrAnyOfYouEmp3
        },
        // Commented the below line for the defect DE1519
        // doOpeIncTheSalOfMed13: {
        //     disabled: true
        // },
        ifYesPleExp18: {
            visible: !_.isUndefined(modelVM.value.doYouProTraToCli17) && modelVM.value.doYouProTraToCli17
        },
        ifYesDoTheRepThiUse20: {
            visible: !_.isUndefined(modelVM.value.doEmpVolDriTheOwnVeh19) && modelVM.value.doEmpVolDriTheOwnVeh19
        },
        ifYesDoTheCarAMin21: {
            visible: !_.isUndefined(modelVM.value.doEmpVolDriTheOwnVeh19) && modelVM.value.doEmpVolDriTheOwnVeh19
        },
        ifYesIsACerOfIns22: {
            visible: !_.isUndefined(modelVM.value.doEmpVolDriTheOwnVeh19) && modelVM.value.doEmpVolDriTheOwnVeh19
        },
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

BusinessOperations2Component.propTypes = wizardProps;
export default withRouter(BusinessOperations2Component);
